import { fileUrl } from "@/lib/api";

export const CompanyAvatar = ({ c, size = "h-14 w-14", text = "text-xl" }) =>
  c?.logo_url ? (
    <img src={fileUrl(c.logo_url)} alt={`${c.name} logo`} className={`${size} rounded-xl object-cover border border-[#2A1240]/10 bg-[#FBE9F3]`} />
  ) : (
    <span className={`${size} ${text} grid place-items-center rounded-xl border border-[#E0218A]/30 bg-[#FBE9F3] font-display text-[#8E2BC4]`}>
      {(c?.name || "?").slice(0, 1)}
    </span>
  );
